import {HeaderTitle} from '@/components/atoms'
import {PageHeader} from '@/components/molecules'
import {RewardCatalogList} from '@/containers/RewardCatalog/RewardCatalogList'
import {Header} from '@/utils/constants/header'
import { NOTIFICATION_TITLES } from '@/utils/constants/commonConstants'
import NotificationAlert from '@/components/atoms/Toast/NotificationAlert'
import { useState, useEffect } from 'react'
import { useAppSelector, useAppDispatch } from '@/store'
import { 
  selectOpenUpload,
  selectUploadErrorMessage,
  selectUploading,
  selectSuccessfullyUploaded,
  openUploadModal
} from '@/store/slices/rewardBulkUpload'

// Notification configurations object
const NOTIFICATION_CONFIGS = {
  error: {
    type: 'error',
    message: {
      title: NOTIFICATION_TITLES.ERROR_UPLOADING_REWARD_LIST,
      subTitle: NOTIFICATION_TITLES.UPLOAD_FAILED_SUBTITLE
    },
    show: true,
    arrowButton: true,
    iconType: 'error_outline'
  },
  info: {
    type: 'info',
    message: {
      title: NOTIFICATION_TITLES.UPLOADING_REWARD_LIST,
      subTitle: NOTIFICATION_TITLES.UPLOADING_SUBTITLE
    },
    show: true,
    arrowButton: true,
    iconType: 'error_outline'
  },
  success: {
    type: 'success',
    message: {
      title: NOTIFICATION_TITLES.REWARDS_LIST_SUCCESSFULLY_PUBLISHED,
    },
    show: true,
    arrowButton: true,
    buttonShow: true,
    iconType: 'check_circle_outline'
  }
};

// Function to get notification config
const getNotificationConfig = (notificationState = 'info') => {
  return NOTIFICATION_CONFIGS[notificationState];
};


const RewardCatalogHome = ({instanceKey}) => {
  const dispatch = useAppDispatch();
  
  // Get upload states from Redux store
  const openUpload = useAppSelector(selectOpenUpload);
  const uploadErrorMessage = useAppSelector(selectUploadErrorMessage);
  const uploading = useAppSelector(selectUploading);
  const successfullyUploaded = useAppSelector(selectSuccessfullyUploaded);

  // Handle opening modal through Redux action
  const handleOpenModal = () => {
    dispatch(openUploadModal());
  };
  
  const [notificationState, setNotificationState] = useState(null);

  // Update notification state based on upload conditions
  useEffect(() => {
    if (!openUpload && uploadErrorMessage) {
      setNotificationState('error');
    } else if (!openUpload && successfullyUploaded) {
      setNotificationState('success');
    } else if (!openUpload && uploading) {
      setNotificationState('info');
    } else {
      setNotificationState(null);
    }
  }, [openUpload, uploadErrorMessage, successfullyUploaded, uploading]);

  const notificationConfig = getNotificationConfig(notificationState);

  return (
    <div key={instanceKey} className="rewardCatalogContainer flex flex-col">
      <PageHeader title="Reward Catalog" />
      <NotificationAlert 
        type={notificationConfig?.type}
        message={notificationConfig?.message}
        show={notificationConfig?.show}
        arrowButton={notificationConfig?.arrowButton}
        iconType={notificationConfig?.iconType}
        buttonShow={notificationConfig?.buttonShow}
        handleArrow={handleOpenModal}
      />
      <div style={{backgroundColor: '#1D1D1D', paddingLeft: '16px'}} className="rewardCatalogTitleSection relative">
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title="Reward Catalog List"
          className="rewardCatalogDataTableHeading"
        />
        <RewardCatalogList />

      </div>
    </div>
  )
}

export default RewardCatalogHome
